<template>
  <div class="custom-page-content">
    <!-- <FeatureCategory/> -->
    <FeatureProducts/>
    <div class="widget"
      v-for="widget in items"
      :key="widget.Id"
       :data-Name="widget.Name" v-html="widget.Body">
    </div>
    <home-article/>
    <faqs/>
  </div>
</template>

<script>
/* globals Store */
import { mapState } from "vuex";
// import FeatureCategory from "@/components/FeatureCategory";
import FeatureProducts from "@/components/FeatureProducts";
import Faqs from "@/components/faqs";
import HomeArticle from "./HomeArticle";
export default {
  components: {
    // FeatureCategory,
    FeatureProducts,
    HomeArticle,
    Faqs
  },
  metaInfo() {
    return {
      title: 'Trang chủ'
    }
  },
  methods: {
    search() {},
    getHomepage() {
      Store.dispatch("homepage/getItems");
    }
  },
  computed: {
    ...mapState("homepage", {
      items: "items",
      pagination: "pagination",
      loading: "loading",
      mode: "mode",
      snackbar: "snackbar",
      notice: "notice"
    }),
  },
  mounted() {
    this.getHomepage();
  },
  created() {
  }
};
</script>



// WEBPACK FOOTER //
// Home.vue?7f8fe606